// src/components/CartSummary.jsx
import React from "react";

const CartSummary = ({ photoTotal, catalogTotal, hasPhotoItems, hasCatalogItems, usbDriveOption }) => {
  const subtotal = Number(photoTotal) + Number(catalogTotal);
  const totalPrice = usbDriveOption ? subtotal + 10 : subtotal;

  return (
    <div className="cart-summary">
      {hasPhotoItems && (
        <div className="summary-row">
          <span>Photo Items Subtotal:</span>
          <span>${photoTotal}</span>
        </div>
      )}
      {hasCatalogItems && (
        <div className="summary-row">
          <span>Catalog Items Subtotal:</span>
          <span>${catalogTotal}</span>
        </div>
      )}
      {usbDriveOption && (
        <div className="summary-row">
          <span>USB Drive:</span>
          <span>$10.00</span>
        </div>
      )}
      <div className="summary-row total">
        <span>Total:</span>
        <span>${totalPrice.toFixed(2)}</span>
      </div>
      <div className="summary-row tax-note">
        <span>
          *Taxes not included - will be calculated at register
        </span>
      </div>
    </div>
  );
};

export default CartSummary;